import { useState, useEffect } from 'react'
import storage from 'utils/storage'
import { getPivoUrl } from 'utils/isSourceOrigin'

const backToHomeRedirect = () => {
  const [toUrl, setToUrl] = useState('/')

  const pivoUrl = getPivoUrl()

  useEffect(() => {
    const homePath = '/'

    const isLojasAvenida = storage.local.getItem('isLojasAvenida')
      ? '/lojasavenida'
      : homePath

    setToUrl(pivoUrl || isLojasAvenida || homePath)
  }, [])

  return toUrl
}

export default backToHomeRedirect
